(function () {
    'use strict';
    angular.module('emarket.main.statics', [ 'ui.router' ])
      .config(['$stateProvider', function ($stateProvider) {
          $stateProvider
        .state('main.statics', {
            views: {
                main: {
                    template:'<ui-view name="statics"></ui-view>'
                }
            }
        })
        .state('main.statics.faqs', {
            url: '/faqs?t?a',
            views: {
                statics: {
                    controller: 'StaticController as vm',
                    templateUrl: 'main/statics/faqs/faqs.tpl.html'
                }
            }
        });
      }]);
}());

(function () {
    'use strict';
    angular.module('emarket.main.statics', [ 'ui.router' ])
      .config(['$stateProvider', function ($stateProvider) {
          $stateProvider
        .state('main.statics', {
            views: {
                main: {
                    template:'<ui-view name="statics"></ui-view>'
                }
            }
        })
        .state('main.statics.faqs', {
            url: '/faqs?t?a',
            views: {
                statics: {
                    controller: 'StaticController as vm',
                    templateUrl: 'main/statics/faqs/faqs.tpl.html'
                }
            }
        });
      }]);
}());
